export function parseStringTable(text) {
    const headerRowText = text.split("\n", 1)[0];
    const rowsText = text.split("\n").slice(2);
    const headerRow = headerRowText.split("|").slice(1, -1);
    const rows = rowsText.map((rowText) => rowText.split("|").slice(1, -1)).filter(value => value.length > 0);
    return [headerRow, ...rows];
}